export enum ListingFilterKeys {
  ALL = 'all',
  ACTIVE = 'active',
  SOLD = 'sold',
  HISTORICAL = 'historical',
  SALE_PENDING = 'sale_pending'
}
